import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useContextHook } from "../../Context/ContextOPen";
import { useContextChat } from "../../Context/ContextChat";

export const baseUrl = "https://backend.qiranbook.com/api/";
export const fileUrl = "https://backend.qiranbook.com/storage/";

export const gender = sessionStorage.getItem("gender");
export const browserName = navigator.appName;
export const browserVersion = navigator.appVersion;
export const language = localStorage.getItem("language") || "ar";
export let checkToken = localStorage.getItem("token");

const getApiHeaders = () => {
  checkToken = localStorage.getItem("token"); 
  return {
    headers: {
      Authorization: "Bearer " + checkToken,
      'finger-print': `${browserName} ${browserVersion}`,
      locale: language,
    },
  };
};

export const checkLanguageEn = language === "en";
export let direction = { direction: language === "ar" ? "rtl" : "ltr" };
export let ltrDirection = { direction: "ltr" };

//!=============================================================> post data login
export const useLOGIN = (initialState) => {
  const [successfulPost, setSuccessfulPost] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setListError } = useContextHook();
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSubmit = async (url, dataToSend) => {
    setLoading(true);
    setError("");
    const finalData = dataToSend || formData;
    const formDataInstance = new FormData();
    for (const [key, value] of Object.entries(finalData)) {
      if (value !== null && value !== undefined) {
        formDataInstance.append(key, value);
      }
    }
    axios
      .post(`${baseUrl}${url}`, formDataInstance, getApiHeaders())
      .then((req) => {
        setLoading(false);
        setSuccessfulPost(true);
        setError("");
        localStorage.setItem("token", req?.data?.data?.token);
        const user = req.data.data.user;

        if (user && (!user.social_status || user.social_status.age === null)) {
            navigate("/profile/edit");
        } else {
            navigate("/");
        }
        
        setTimeout(() => window.location.reload(false), 200);
      })
      .catch((e) => {
        setSuccessfulPost(false);
        setError(e.response?.data?.message);
        const errors = e.response?.data?.errors || [e.response?.data?.message] || ["An unexpected error occurred."];
        setListError(Array.isArray(errors) ? errors : [errors]);
        setLoading(false);
      });
  };

  return { formData, handleChange, loading, error, handleSubmit, setFormData, setError, successfulPost };
};

//!======================================================================================
export const usePOST = (initialState, isJson) => {
    const [formData, setFormData] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [response, setResponse] = useState();
    const [viewFile, setViewFile] = useState("");
    const [viewImages, setViewImages] = useState([]);
    const [images, setImages] = useState({});
    const [checkArray, setCheckArray] = useState({});
    const [successfulPost, setSuccessfulPost] = useState(0);
    const [counter, setCounter] = useState(0);
    const navigate = useNavigate();
    const { showMessagesSign, setListError } = useContextHook();
  
    const handleChangeInput = (event) => {
      const { name, value, type, files, checked } = event.target;
      const newValue =
        type === "file" ? files[0] : type === "checkbox" ? checked : value;
      type === "file" && setViewFile(URL.createObjectURL(newValue));
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: newValue === true ? 1 : newValue === false ? 0 : newValue,
      }));
    };
  
    const handleChangeSelect = (selected, active) => {
      setFormData({
        ...formData,
        ["option_" + active.name]: selected,
        [active.name]: Array.isArray(selected)
          ? selected.map((e) => e.value)
          : selected.value,
      });
    };
  
    const handleChangeArrayImages = (event) => {
      const files = event.target.files;
      const newFilesObject = {};
      const currentImagesCount = Object.keys(images).length;
  
      for (let i = 0; i < files.length; i++) {
        newFilesObject[`images[${currentImagesCount + i}]`] = files[i];
      }
  
      setImages((prevImages) => ({
        ...prevImages,
        ...newFilesObject,
      }));
  
      const urlImages = [];
      for (let i = 0; i < files.length; i++) {
        if (!files[i]) continue;
        urlImages.push({
          name: files[i].name,
          value: URL.createObjectURL(files[i]),
        });
      }
  
      setViewImages((prev) => [...prev, ...urlImages]);
      event.target.value = "";
    };
  
    const handleCheckedArray = (e) => {
      const { value, checked, name } = e.target;
      if (checked) {
        setCheckArray((prev) => ({
          ...prev,
          [name]: prev[name] ? [...prev[name], value] : [value],
        }));
      } else {
        setCheckArray((prev) => ({
          ...prev,
          [name]: prev[name]?.filter((p) => p !== value) || [],
        }));
      }
    };
  
    const handleSubmit = (url, reload, route, noRoute, data) => {
      return new Promise((resolve, reject) => {
        setSuccessfulPost(0);
        setLoading(true);
        setError("");
    
        const formDataToSend = new FormData();
        const sourceData = data || formData;
    
        for (const [key, value] of Object.entries(sourceData)) {
            if (value !== null && value !== undefined && value !== '') {
                formDataToSend.append(key, value);
            }
        }
    
        for (const [key, value] of Object.entries(checkArray)) {
            value.forEach((v) => formDataToSend.append(key, v));
        }
    
        for (const [key, value] of Object.entries(images)) {
            formDataToSend.append(key, value);
        }
    
        axios.post(`${baseUrl}${url}`, isJson ? formData : formDataToSend, getApiHeaders())
          .then((req) => {
            setSuccessfulPost(1);
            setLoading(false);
            setError("");
            setResponse(req.data);
    
            if (route) navigate(route);
            else if (noRoute) console.log("No route redirection");
            else if (reload) window.location.reload();
            
            resolve(req.data); 
          })
          .catch((e) => {
            setLoading(false);
            setSuccessfulPost(0); 
            const apiErrors = e.response?.data?.errors;
            const message = e.response?.data?.message || "حدث خطأ غير متوقع";
    
            if (Array.isArray(apiErrors)) {
              setListError([...apiErrors]);
            } else if (typeof apiErrors === "object" && apiErrors !== null) {
              setListError(Object.values(apiErrors).flat());
            } else {
              setListError([message]);
            }
    
            setError(message);
    
            if (e.request?.status === 401) {
              showMessagesSign();
              localStorage.clear();
            }
            if (e.request?.status === 403) navigate("/403");
            if (e.request?.status === 500) navigate("/500");

            reject(e); 
          });
      });
    };
  
    return {
      formData, setFormData, viewFile, setViewFile, viewImages, setViewImages,
      images, setImages, error, setError, loading, setLoading, handleChangeInput,
      handleChangeSelect, handleCheckedArray, handleChangeArrayImages,
      handleSubmit, successfulPost, counter, setCounter, response,
    };
};

export const logout = (url) => {
    axios.post(`${baseUrl}${url}`, {}, getApiHeaders()) 
        .then((req) => {
            if (url.includes("ads")) return;
            localStorage.removeItem("token");
            window.location.reload();
        })
        .catch(() => {});
};

//!=============================================================>start fetch data
export const useFETCH = (
  url,
  urlDelete,
  reload,
  checkDelMessage,
  e403,
  refresh = 1,
  isPolling = false
) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [successfulDelete, setSuccessfulDelete] = useState(0);
  const [error, setError] = useState();
  const [isError, setIsError] = useState("");
  const [successfulDeleteIgnore, setsuccessfulDeleteIgnore] = useState(0);
  const [successfulDeleteCare, setsuccessfulDeleteCare] = useState(0);
  const navigate = useNavigate();
  const { showMessagesSign, setListError } = useContextHook();
  const { setMessageDelete } = useContextChat();

  useEffect(() => {
    if (!isPolling) {
      setIsLoading(true);
    }
    if (url) {
      axios.get(`${baseUrl}${url}`, getApiHeaders()) 
        .then((req) => {
          if (req) {
            setData(req);
            setIsLoading(false);
            setIsError("");
            setError(undefined);
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setIsError("خطأ في جلب البيانات");
          if (e.request.status === 401) {
            localStorage.removeItem("token");
            if (reload != -1) {
              showMessagesSign();
            }
          }
          setError(e.response?.data || e.message || "حدث خطأ غير متوقع");
          if (e.request.status === 403 && e403) {
            navigate("/chat/err/403");
          }
        });
    } else setIsLoading(false);
  }, [url, successfulDelete, refresh]);

  const deleteCare = async (id) => {
    setIsLoading(true);
    setsuccessfulDeleteCare(0);
    axios.delete(`${baseUrl}v1/care/${id}/delete`, getApiHeaders()) 
      .then((req) => {
        setIsLoading(false);
        setsuccessfulDeleteCare(id);
      })
      .catch((e) => {
        setIsLoading(false);
        setListError([...e.response?.data?.errors]);
        setIsError(" خطأ في إلغاء الإهتمام");
      });
  };

  const deleteIgnore = async (id) => {
    setIsLoading(true);
    setsuccessfulDeleteIgnore(0);
    axios.delete(`${baseUrl}v1/ignore/${id}/delete`, getApiHeaders()) 
      .then((req) => {
        setIsLoading(false);
        setsuccessfulDeleteIgnore(id);
      })
      .catch((e) => {
        setIsLoading(false);
        setListError([...e.response?.data?.errors]);
        setIsError(" خطأ في الحظر");
      });
  };

  const deleteItem = async (id, toDeleteUrl) => {
    setIsLoading(true);
    setSuccessfulDelete(0);
    axios.delete(`${baseUrl}${toDeleteUrl}`, getApiHeaders()) 
      .then((req) => {
        setIsLoading(false);
        setIsError("تم الحذف بنجاح");
        if (checkDelMessage) {
          setMessageDelete(id);
        } else if (reload) {
          window.location.reload(false);
        } else {
          setSuccessfulDelete(id);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        setListError([...e.response?.data?.errors]);
        setIsError(" خطأ في الحذف  حاول مرة آخرى");
      });
  };

  return {
    data, isLoading, isError, deleteItem, successfulDelete, setSuccessfulDelete, deleteIgnore,
    successfulDeleteIgnore, deleteCare, successfulDeleteCare, setData, error, setIsLoading,
  };
};

export const useFilter = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const handleParamsClick = (name, value) => {
      if (value === "") {
        handleParamsDelete(name);
      } else {
        searchParams.set(name, value);
        const newUrl = `${location.pathname}?${searchParams.toString()}`;
        navigate(newUrl);
      }
    };
    const handleParamsDelete = (name) => {
      searchParams.delete(name);
      const newUrl = `${location.pathname}?${searchParams.toString()}`;
      navigate(newUrl);
    };
    const handleParamsDeleteAll = (name) => {
      const newUrl = `${location.pathname}`;
      navigate(newUrl);
    };
    const handlePageClick = (event) => {
      handleParamsClick("page", event.selected + 1);
    };
    return { searchParams, handlePageClick, handleParamsClick, handleParamsDelete, handleParamsDeleteAll };
  };

export const useClose = () => {
    const [open, setOpen] = useState(false);
    const mouse = useRef();
    useEffect(() => {
      const handler = (e) => {
        if (mouse.current) {
          if (!mouse.current.contains(e.target)) {
            setOpen(false);
          }
        }
      };
      document.addEventListener("mousedown", handler);
      return () => {
        document.removeEventListener("mousedown", handler);
      };
    }, []);
    return { open, setOpen, mouse };
  };
  
export const RequireAuth = () => {
    if (!checkToken) {
      return <Navigate to="/auth/sign-in" />;
    }
    return <Outlet />;
  };

export const RequireLogin = () => {
    const { pathname } = useLocation();
    if (checkToken && !pathname.includes("/admin/sign-in/")) {
      return <Navigate to="/" />;
    }
    return <Outlet />;
  };

export const clickZoomInImage = (event) => {
    event.target.requestFullscreen();
  };